export default Object.freeze({
  holiday:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/holidays-calendar-card.png',
  default1:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/default1-calendar-card.png',
  default2:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/default2-calendar-card.png',
  default3:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/default3-calendar-card.png',
  default4:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/default4-calendar-card.png',
  default5:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/default5-calendar-card.png',
  easter:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/easter-calendar-card.png',
  goodFriday:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/goodFriday-calendar-card.png',
  newYearsDay:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/newYearsDay-calendar-card.png',
  newYearsEve:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/newYearsEve-calendar-card.png',
  athletics:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/athletics-calendar-card.png',
  christmas:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/xmas-calendar-card.png',
  learning:
    'https://anzukmedia.blob.core.windows.net/assets/rrVue/schedule-cards/default1-calendar-card.png',
})
